import { Content } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import DidsHeader from "./DidsHeader";
import DidsList from "./DidsList";
import { Flex } from "antd";
import Loader from "../../generic/Loader";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useGetCarriers } from "../../../hooks/apis/carriers.api";
import { usePermissions } from "../../../hooks/permissions";
import { Did } from "../../../interfaces/Did.type";
import { useGetDidsByAccountId } from "../../../hooks/apis/SmsDids.api";
import { useGetDidUsersByAccount } from "../../../hooks/apis/userDids";

const contentStyle: React.CSSProperties = {
    height: "100%",
    borderRight: "1px solid rgb(223, 226, 232)",
    background: "#ffff",
    padding: "10px",
};

const spinStyle: React.CSSProperties = {
    width: "100%",
    height: "calc(100% - 80px)",
};

const DidsContainer = ({
    selectedDid,
    setSelectedDid,
}: {
    selectedDid: Did | null
    setSelectedDid: Function
}) => {
    const [searchInput, setSearchInput] = useState<string>("");
    const { selectedAccount } = useSelector((state: RootState) => state.admin)
    const dids = useSelector((state: RootState) => state.dids)
    const { hasPermission, hasPermission2 } = usePermissions()


    const { refetch: fetchCarriers } = useGetCarriers()
    const { refetch: fetchDids, isLoading, isRefetching: isDidsRefetching } = useGetDidsByAccountId()
    const { refetch: fetchUserDids } = useGetDidUsersByAccount(selectedAccount)

    useEffect(() => {
        if (selectedAccount) {
            fetchDids()
            fetchUserDids()
        }
    }, [selectedAccount])

    useEffect(() => {
        if (hasPermission("sms", "readGateways:any") || hasPermission2("sms.gateways.view", "system")) {
            fetchCarriers()
        }
    }, [])

    return (
        <Content style={contentStyle}>
            <DidsHeader
                setSearchInput={setSearchInput}
            />
            {(isLoading || isDidsRefetching) ?
                <Flex style={spinStyle} justify="center" align="center">
                    <Loader />
                </Flex>
                :
                <DidsList
                    selectedDid={selectedDid}
                    dids={!searchInput ? dids : dids.filter((did) => {
                        return did.did?.includes(searchInput) ||
                            did.label?.toLowerCase().includes(searchInput.toLowerCase())
                    })
                    }
                    setCurrentDid={setSelectedDid}
                />
            }
        </Content>
    );
};

export default DidsContainer;
